import { useTranslation } from "react-i18next";

import { OrderAtomProps } from "../../OrderModal.types";
import { OrderModalBlock } from "./OrderModalBlock";

import styles from "../../OrderModal.module.scss";

export const OrderPrice = ({ orderDetails }: OrderAtomProps) => {
  const { t } = useTranslation();

  return (
    <OrderModalBlock label={t("Price Details")}>
      <div className={styles.orderModal__priceBlock__item}>
        <p>{t("Product Price")}</p>
        <p className={styles.orderModal__priceBlock__itemPrice}>
          {orderDetails?.totalPriceWithoutDiscount?.toLocaleString("en-US")}{" "}
          FCFA
        </p>
      </div>

      {Number(orderDetails?.itemsDiscount) !== 0 && (
        <div className={styles.orderModal__priceBlock__item}>
          <p>{t("Products Total Discount")}</p>
          <p className={styles.orderModal__priceBlock__itemPrice_discount}>
            - {orderDetails?.itemsDiscount?.toLocaleString("en-US")} FCFA
          </p>
        </div>
      )}

      {Number(orderDetails?.couponDiscount) !== 0 && (
        <div className={styles.orderModal__priceBlock__item}>
          <p>{t("Coupon Discount")}</p>
          <p className={styles.orderModal__priceBlock__itemPrice_discount}>
            - {orderDetails?.couponDiscount?.toLocaleString("en-US")} FCFA
          </p>
        </div>
      )}

      {!!orderDetails.totalMargin && (
        <>
          <div className={styles.orderModal__separator} />

          <div className={styles.orderModal__priceBlock__item}>
            <p>{t("Order Total")}</p>
            <p className={styles.orderModal__priceBlock__itemPrice_total}>
              {(
                orderDetails.totalOrder -
                orderDetails.totalMargin -
                orderDetails.deliveryFee
              ).toLocaleString("en-US")}{" "}
              FCFA
            </p>
          </div>
        </>
      )}

      {!!orderDetails.totalMargin && (
        <div className={styles.orderModal__priceBlock__item}>
          <p>{t("Margin Earned")}</p>
          <p className={styles.orderModal__priceBlock__itemPrice_margin}>
            {orderDetails.totalMargin > 0 ? "+" : ""}
            {orderDetails.totalMargin.toLocaleString("en-US")} FCFA
          </p>
        </div>
      )}

      {Number(orderDetails.deliveryFee) !== 0 && (
        <div className={styles.orderModal__priceBlock__item}>
          <p>{t("Delivery fee")}</p>
          <p className={styles.orderModal__priceBlock__itemPrice_total}>
            {orderDetails.deliveryFee.toLocaleString("en-US")} FCFA
          </p>
        </div>
      )}

      <div className={styles.orderModal__separator} />

      <div className={styles.orderModal__priceBlock__total}>
        <p>{t("Final Price")}</p>
        <p className={styles.orderModal__priceBlock__totalPrice}>
          {orderDetails.totalOrder.toLocaleString("en-US")} FCFA
        </p>
      </div>
    </OrderModalBlock>
  );
};
